import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, NavigationIcon, CalendarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function LocationInfo() {
  return <section id="contact" className="py-16 md:py-24 px-4 bg-white" data-id="element-220">
      <div className="max-w-7xl mx-auto" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-222">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-pulse-navy uppercase tracking-tight" data-id="element-223">
            Coming to Midlothian
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-224">
            We're building the ultimate entertainment destination right in your
            backyard.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-225">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-226">
            {/* Address */}
            <div className="flex gap-4" data-id="element-227">
              <div className="w-12 h-12 rounded-xl bg-pulse-blue/10 flex items-center justify-center flex-shrink-0" data-id="element-228">
                <MapPinIcon className="h-6 w-6 text-pulse-blue" data-id="element-229" />
              </div>
              <div data-id="element-230">
                <h3 className="font-bold text-pulse-navy text-lg mb-1" data-id="element-231">
                  Future Location
                </h3>
                <p className="text-gray-600" data-id="element-232">
                  1234 Entertainment Blvd
                  <br data-id="element-233" />
                  Midlothian, VA 23112
                </p>
              </div>
            </div>

            {/* Opening */}
            <div className="flex gap-4" data-id="element-234">
              <div className="w-12 h-12 rounded-xl bg-pulse-yellow/10 flex items-center justify-center flex-shrink-0" data-id="element-235">
                <CalendarIcon className="h-6 w-6 text-pulse-yellow" data-id="element-236" />
              </div>
              <div data-id="element-237">
                <h3 className="font-bold text-pulse-navy text-lg mb-1" data-id="element-238">
                  Opening
                </h3>
                <p className="text-gray-600 font-medium" data-id="element-239">Coming in 2027</p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex gap-4" data-id="element-240">
              <div className="w-12 h-12 rounded-xl bg-pulse-orange/10 flex items-center justify-center flex-shrink-0" data-id="element-241">
                <PhoneIcon className="h-6 w-6 text-pulse-orange" data-id="element-242" />
              </div>
              <div data-id="element-243">
                <h3 className="font-bold text-pulse-navy text-lg mb-1" data-id="element-244">
                  Phone
                </h3>
                <p className="text-gray-600" data-id="element-245">
                  (804) 555-1234
                  <span className="block text-sm text-gray-400 mt-1" data-id="element-246">
                    Lines open closer to launch
                  </span>
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="flex gap-4" data-id="element-247">
              <div className="w-12 h-12 rounded-xl bg-pulse-blue/10 flex items-center justify-center flex-shrink-0" data-id="element-248">
                <MailIcon className="h-6 w-6 text-pulse-blue" data-id="element-249" />
              </div>
              <div data-id="element-250">
                <h3 className="font-bold text-pulse-navy text-lg mb-1" data-id="element-251">
                  Email
                </h3>
                <a href="mailto:info@pulseentertainment.com" className="text-gray-600 hover:text-pulse-orange transition-colors" data-id="element-252">
                  info@pulseentertainmentva.com
                </a>
              </div>
            </div>
          </motion.div>

          {/* Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-253">
            <div className="aspect-[4/3] bg-gradient-to-br from-pulse-navy-light to-pulse-navy rounded-2xl overflow-hidden relative" data-id="element-254">
              {/* Map Pattern */}
              <div className="absolute inset-0 opacity-20" data-id="element-255">
                <div className="absolute inset-0" style={{
                backgroundImage: `
                    linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                    linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
                  `,
                backgroundSize: '40px 40px'
              }} data-id="element-256" />
              </div>

              {/* Center Pin */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-257">
                <motion.div animate={{
                y: [0, -10, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity
              }} className="relative" data-id="element-258">
                  <div className="w-16 h-16 bg-pulse-orange rounded-full flex items-center justify-center shadow-lg" data-id="element-259">
                    <MapPinIcon className="h-8 w-8 text-white" data-id="element-260" />
                  </div>
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-8 h-2 bg-black/20 rounded-full blur-sm" data-id="element-261" />
                </motion.div>
              </div>

              {/* Location Label */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg" data-id="element-262">
                <div className="flex items-center justify-between" data-id="element-263">
                  <div data-id="element-264">
                    <p className="font-bold text-pulse-navy" data-id="element-265">
                      Pulse Entertainment Center
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-266">
                      Midlothian, VA 23112
                    </p>
                  </div>
                  <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-pulse-blue text-white px-4 py-2 rounded-full text-sm font-bold hover:bg-sky-500 transition-colors" data-id="element-267">
                    <NavigationIcon className="h-4 w-4" data-id="element-268" />
                    Directions
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}